import { FACILITY_DISPATCH_TARGET_FACILITY } from "redux/facilityDispatchMeta";
import { IPutTeeSheetSettings } from "api/rpc/2024-04/facilityAdmin/facility/settings";
import { IKitchenCourse } from "pages/secure/facility/settings/kitchenCourse/KitchenCourse";
import { IFacility, IFacilityStaff, TWeather } from "./models/facility";
import { TProductRequirements } from "./models/product";
import { IRegister } from "pages/secure/facility/Admin";
import { ILoyaltyProgram, IOffer } from "./models/loyalty";

export interface IFacilityState {
  isLoaded: boolean;
  error?: any;
  facility?: IFacility;
  weather?: TWeather;
  paymentOptions: any[];
  discountOptions: any[];
  teeSheetSettings?: IPutTeeSheetSettings;
  printerSettings?: any;
  kitchenCourses?: Array<IKitchenCourse>;
  facilities: IFacility[];
  staffAccounts: IFacilityStaff[];
  registers: IRegister[];
  validationNewProduct: {
    required?: TProductRequirements;
  };
  selectedFloorPlanId: number;
  openRegistersSheet: boolean;
  loyaltyProgram: ILoyaltyProgram;
  loyaltyProgramOffers: Array<IOffer>;
  serviceFees: any[];
}

export interface IFacilityAction {
  type: string;
  payload: any;
  meta?: { facilityDispatchTarget?: typeof FACILITY_DISPATCH_TARGET_FACILITY };
}

const initialState: IFacilityState = {
  isLoaded: false,
  error: null,
  facility: null,
  weather: null,
  paymentOptions: [],
  discountOptions: [],
  teeSheetSettings: null,
  printerSettings: null,
  kitchenCourses: [],
  facilities: [],
  staffAccounts: [],
  registers: [],
  validationNewProduct: {
    required: undefined,
  },
  selectedFloorPlanId: null,
  openRegistersSheet: false,
  loyaltyProgram: null,
  loyaltyProgramOffers: null,
  serviceFees: [],
};

export default function FacilityReducer(state = initialState, action: IFacilityAction) {
  switch (action.type) {
    case "facility.update":
      if (action.meta?.facilityDispatchTarget !== FACILITY_DISPATCH_TARGET_FACILITY) {
        return state;
      }
      return {
        ...state,
        ...(action.payload as IFacilityState),
      };
    default:
      return state;
  }
}
